import React from "react";
import { motion } from "framer-motion";
import MediaQuery from "react-responsive";
export default function Modal() {
  return <div></div>;
}
